module.exports = __webpack_public_path__ + "img/stars.2143cd5c.svg";